import React, { useCallback, useContext, useState } from 'react';
import { AppContext } from 'src/components/app-context';

import { postFeedback } from '../../../../globals/api/requests';

import { MissingShopModal } from './missing-shop-modal';

import type { SubmitData } from './types';

import { StyledMissingShop, StyledModalButton } from './styles';

const MissingShop = () => {
  const { market, t } = useContext(AppContext);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [error, setError] = useState(false);
  const [sending, setSending] = useState(false);
  const [success, setSuccess] = useState(false);

  const openModal = useCallback(
    (e: React.MouseEvent) => {
      // Stops the PriceRow link and onClick from firing
      e.preventDefault();
      e.stopPropagation();

      setModalIsOpen(true);
    },
    [setModalIsOpen]
  );

  const closeModal = useCallback(() => {
    setModalIsOpen(false);
    setSuccess(false);
  }, [setModalIsOpen]);

  const onSubmitReport = useCallback(
    (e: React.MouseEvent, data: SubmitData) => {
      if (!data.storeId) return;

      const optionalLinkInputMessage = data.optionalLinkInput
        ? `, link to product page: ${data.optionalLinkInput}`
        : '';
      const message = `Missing shop - id: ${data.storeId}, reported on ${window.location.href}${optionalLinkInputMessage}`;

      const postData = {
        message,
        uri: window.location.href,
        agent_type_key: 'store_price_missing',
        store_id: data.storeId,
        country_code: market.code,
      };

      setSending(true);
      postFeedback(postData)
        .then(() => {
          setSending(false);
          setSuccess(true);
        })
        .catch(() => {
          setSending(false);
          setError(true);
        });
    },
    [market.code]
  );

  return (
    <StyledMissingShop>
      {t('product', 'missing-shop.missing-shop-link')}{' '}
      <StyledModalButton onClick={openModal}>
        {t('product', 'missing-shop.missing-shop-click')}
      </StyledModalButton>
      <MissingShopModal
        isOpen={modalIsOpen}
        error={error}
        closeModal={closeModal}
        sending={sending}
        success={success}
        submitReport={onSubmitReport}
      />
    </StyledMissingShop>
  );
};

export default MissingShop;
